import React from 'react';

import { makeStyles } from '@mui/styles';

import Link from '@mui/icons-material/Link';

const useStyles = makeStyles({
  container: {
    height: 38,
    fontSize: 12,
    display: 'flex',
    color: '#168CCE',
    paddingLeft: 20,
    paddingRight: 20,
    cursor: 'pointer',
    opacity: 0.8,
    background: '#FFF',
    alignItems: 'center',
    textTransform: 'capitalize',
    '&:hover': {
      opacity: 1,
    },
  },
  icon: {
    fontSize: 20,
    marginRight: 4,
    color: '#168CCE',
  },
});

const GeneratePublicInvite = ({ subName, onClick }) => {
  const classes = useStyles();

  return (
    <div className={classes.container} onClick={onClick}>
      <Link className={classes.icon} />
      <span>Generate&nbsp;</span>
      <span>
        <strong>{subName}&nbsp;</strong>
      </span>
      <span>invitation link&nbsp;</span>
    </div>
  );
};

export default GeneratePublicInvite;
